import Vue from 'vue';
import Vuetify, {VBtn, VIcon, VSnackbar} from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar';
import 'vuetify/dist/vuetify.min.css';
import VueObserveVisibility from 'vue-observe-visibility';
import '@fortawesome/fontawesome-free/css/all.css'
import {Iconfont} from "vuetify/types/services/icons"; // Ensure you are using css-loader

Vue.use(Vuetify, {
    components: {
        VSnackbar,
        VBtn,
        VIcon,
        rtl: true,
        theme: {dark: true}
    }
});

const opts = {
    theme: {
        options: {customProperties: true},
        dark: false,
        themes: {
            dark: {
                appBackground: '#F5F5F5',
                background: '#FFFFFF',
                onBackground: '#222',
                primary: '#2C5F60',
                onPrimary: '#ffffff',
                secondary: '#CCE2D3',
                onSecondary: '#2C5F60',
                accent: '#2C5F60',
                onAccent: '#ffffff',
                error: '#ff3f3f',
                info: '#19658b',
                success: '#4cba3e',
                warning: '#efa13d',
            },
            light: {
                appBackground: '#F5F5F5',
                background: '#FFFFFF',
                onBackground: '#222',
                primary: '#2C5F60',
                onPrimary: '#ffffff',
                secondary: '#CCE2D3',
                onSecondary: '#2C5F60',
                accent: '#2C5F60',
                onAccent: '#ffffff',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
        },
    },
    icons: {
        iconfont: "fa" as Iconfont,
    }
}; // your options
const vueObj = new Vuetify(opts);
export default vueObj;
Vue.use(VuetifyToast, {$vuetify: vueObj.framework});

Vue.use(VueObserveVisibility);
